
import Group from 'vux/src/components/group/index.vue'
import PopupPicker from 'vux/src/components/popup-picker/index.vue'

export default {
name: "alliance_cancelback",
components: { Group, PopupPicker},
data() {
return {
title: "意见反馈",
url: window.location.href, //当前地址
reason:[['门店关闭、转让','商家拒绝兑换','其他']],
shop_name:this.$route.query.shop_name?this.$route.query.shop_name:'',//获取店铺名称
hasShop:this.$route.query.shop_name?true:false,//是否有店铺名称
category:[],//原因
phone:"",//电话
content:"",//反馈内容
id:this.$route.query.id
};
},
created() {
if (sessionStorage.getItem("token") == null) {
this.get_token(this.url);
}

},

methods: {
get_token(url) {
this.$EpetJs.Common.approve(url,function() {}); 
},

category_change(val){
this.category=val;
},

submit() {
var self = this;
if(this.shop_name==''){
self.$vux.toast.text('请输入店铺名！');
return;
}
if(this.category==''){
self.$vux.toast.text('请选择无法使用理由！');
return
}
if(this.phone==''){
self.$vux.toast.text('请输入手机号！');
return
}
if(this.phone){
if(!(/^1[3456789]{1}\d{9}$/.test(this.phone))){
self.$vux.toast.text("请输入正确的手机号");
return;
}
}
if(this.content==''){
self.$vux.toast.text("请输入详细说明内容");
return;
}
this.$EpetJs.Common.post("/v2/public/consumer/feedback/gifts/"+this.id, {
id:this.id,
shop_name: this.shop_name,
category: this.category[0]=='门店关闭、转让'?'1':this.category[0]=='商家拒绝兑换'?'2':'3',
phone: this.phone,
content: this.content,
}).then(({ data }) => {
if (data.status_code == "200") {
self.$vux.toast.show({type:'text',text:'反馈成功',width:'auto',onHide(){
self.$router.push({name: "alliance_coupondetail",query:{id:self.id}
});
}});
} else {
self.$vux.toast.text(data.message);
}
});
},

}
};
